import { render, staticRenderFns } from "./AvailablePlansModal.vue?vue&type=template&id=28d24554&scoped=true&"
import script from "./AvailablePlansModal.vue?vue&type=script&lang=js&"
export * from "./AvailablePlansModal.vue?vue&type=script&lang=js&"
import style0 from "./AvailablePlansModal.vue?vue&type=style&index=0&id=28d24554&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d24554",
  null
  
)

component.options.__file = "AvailablePlansModal.vue"
export default component.exports